import { CartRemoveIcon } from './CartRemoveIcon';

/**
 * author: Simran
 * id DCB745AA-0ECB-4584-88DA-52CC447555A0
 * name cart-remove
 * version: 3.4.93
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cart-remove.svg
 * tags
 * - Shopping 
 */
export const ShoppingCartRemoveIcon = CartRemoveIcon;
export default ShoppingCartRemoveIcon